module.exports = __webpack_public_path__ + "static/derjenige-der-nicht-weiß-zu-lieben-kampft-01-9d98f0ff1b7e90d63bd2cb5315fb577f.jpg";